export default async () => {
  if (navigator.geolocation) {
    const { coords } = await new Promise((resolve, reject) => {
      return navigator.geolocation.getCurrentPosition(resolve, reject)
    })
    return coords
  } else {
    return new Promise(resolve => resolve({}))
  }
}
